import { createSelector } from '@reduxjs/toolkit';
import { selectClientsState } from '../../store/selectors';

export const selectClientState = createSelector(selectClientsState, (clients) => clients.client);

export const selectPortfolio = createSelector(selectClientState, (client) => client.portfolio);

export const selectDetails = createSelector(selectClientState, (client) => client.details);
